import CircularProgress from '@material-ui/core/CircularProgress';

export default function Loader() {
	return (
		<div class="flex justify-center items-center align-middle w-full h-full">
			<CircularProgress color="primary" />
		</div>
	);
}
